
import { useEffect, useState } from "react";

export function useInactivityNudge(lastVoteRef: React.MutableRefObject<number>) {
  const [inactivityNudge, setInactivityNudge] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastVoteRef.current > 20000)
        setInactivityNudge(true);
    }, 4000);
    return () => clearInterval(interval);
  }, [lastVoteRef]);

  const clearNudge = () => setInactivityNudge(false);

  return { inactivityNudge, clearNudge };
}
